import { apiGetAction } from '../../actions'
import { ApiRoutes } from '../../routes'
import { IUserInfoReadResponse } from '../read'

export function userInfoReadAction(): Promise<IUserInfoReadResponse> {
  return apiGetAction<IUserInfoReadResponse>(ApiRoutes.User.Info.read)
}
